module.exports = "img/button-text-deleted-on.7a2d0b3.svg";